'use client';
import { ArrowLeft, ArrowRight } from '@ethsign/icons';
import { Button } from '@ethsign/ui';

import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLocalStorage } from 'react-use';

import { StepTab } from '@/components/StepTab';

import { TemplateAddFields } from '@/components/TemplateAddFields';

import { useRouter, useSearchParams } from '@/hooks';
import { SendType } from '@/types';
import { useViewModel } from '@/utils/bizify';

import { PageCtrl } from './PageCtrl';

import { ReviewAndSave } from './components/ReviewAndSave';

export function TemplatePage(props: any) {
  const { data } = props;

  const { id = '' } = useParams();
  const searchParams = useSearchParams();
  const sendType = searchParams.sendType as SendType;

  const vm = useViewModel(PageCtrl);
  const router = useRouter();
  const vmData = vm.$useSnapshot();
  const { currentStep, loading, addFieldsData } = vmData;
  const [cacheData, setCacheData] = useLocalStorage<any>(id, {});
  useEffect(() => {
    setData(data);
  }, [data]);

  const setData = (data: any) => {
    setCacheData({
      ...cacheData,
      ...data
    });

    vm.setData(data);
  };

  const steps = [
    {
      title: 'Add Terms'
    },
    {
      title: 'Add Fields'
    },
    {
      title: 'Review and Save'
    }
  ];

  const onCreate = async () => {
    const result = await vm.onCreate(sendType, id.indexOf('temp') >= 0 ? undefined : id);
    if (result) {
      router.replace('/console/template/list');
    }
  };
  const onNext = async () => {
    const result = vm.onNext();
    if (result) {
      if (vmData.currentStep === 2) {
        onCreate();
        return;
      }
      setData({
        currentStep: vmData.currentStep + 1
      });
    }
  };

  const onPrev = () => {
    if (vmData.currentStep === 0) {
      router.replace('/console/template/list');
      return;
    }
    setData({ currentStep: vmData.currentStep - 1 });
  };

  return (
    <div className="bg-white h-full flex flex-col">
      <div className="flex items-center justify-center px-[40px] border-b border-gray-100 h-[72px] text-lg font-medium text-gray-700 relative">
        <div
          className="flex items-center gap-[8px] cursor-pointer  absolute left-10"
          onClick={() => router.push('/console/template/list')}
        >
          <ArrowLeft color={'#344054'} size={16} />
          <span>Dashboard</span>
        </div>
        <StepTab items={steps} current={vmData.currentStep} />
      </div>
      <div className="flex-1 overflow-hidden">
        <TemplateAddFields
          data={addFieldsData}
          isShow={currentStep === 0 || currentStep === 1}
          type={sendType}
          isAddTerms={currentStep === 0}
          onDataChange={(data) => {
            setData({
              addFieldsData: data
            });
          }}
        />
        {currentStep === 2 && <ReviewAndSave data={vmData} setData={setData} />}
      </div>
      <div className="h-[82px] bg-white w-full bottom-0 px-[40px] py-[20px] flex justify-between items-center shadow-xs border border-top-1 border-gray-100">
        <Button variant="outline" onClick={onPrev}>
          <ArrowLeft color={'#344054'} size={16} /> Back
        </Button>
        <Button onClick={() => onNext()} loading={loading}>
          Next <ArrowRight color={'#FFFFFF'} size={16} />
        </Button>
      </div>
    </div>
  );
}
